import JsonApi from "@/custolink-logic/api/JsonApi";


export enum AdmAssetsQrNfcExportApi$ApiJobType { "NfcCodesCsv" = "NfcCodesCsv" , "QrCodesCustolinkLabelsZip" = "QrCodesCustolinkLabelsZip"};

export enum AdmAssetsQrNfcExportApi$LatestJobState { "Errored" = "Errored" , "Pending" = "Pending" , "Success" = "Success"};

export enum AdmAssetsQueryApi$MainAttributeSortColumn { "Number" = "Number" , "SerialNumber" = "SerialNumber"};

export enum AssetProtectionBehavior { "HIDE_ASSET" = "HIDE_ASSET" , "HIDE_FILES" = "HIDE_FILES"};

export interface AdmAssetProtectionApi$AssetProtection {
    assetProtectionEnabled: boolean;
    behavior: AssetProtectionBehavior;
    entries: AdmAssetProtectionApi$AssetProtectionEntryDto[];
    groupOptions: AdmAssetProtectionApi$AssetProtectionGroupEntryDto[];
    groups: AdmAssetProtectionApi$AssetProtectionGroupEntryDto[];
}

export interface AdmAssetProtectionApi$AssetProtectionEntryDto {
    emailOrDomain: string;
}

export interface AdmAssetProtectionApi$AssetProtectionGroupEntryDto {
    id: number;
    name: string;
}

export interface AdmAssetProtectionApi$AssetProtectionInput {
    entries: AdmAssetProtectionApi$AssetProtectionEntryDto[];
    groupIds: number[];
}

export interface AdmAssetsApi$AssetAttributeEdit {
    attrId: number;
    attrValue: string | null;
}

export interface AdmAssetsApi$AssetEdit {
    assetId: number;
    attrEdits: AdmAssetsApi$AssetAttributeEdit[];
    productName: string;
}

export interface AdmAssetsApi$BulkAssetDelete {
    assetIds: number[];
}

export interface AdmAssetsApi$BulkAssetEdits {
    list: AdmAssetsApi$AssetEdit[];
}

export interface AdmAssetsApi$CheckSerialnumber {
    serialnumber: string;
}

export interface AdmAssetsApi$CheckSerialnumberResult {
    exists: boolean;
}

export interface AdmAssetsApi$CreateAsset {
    attributes: AdmAssetsApi$CreateAssetAttribute[];
    productName: string;
    serialnumber: string;
}

export interface AdmAssetsApi$CreateAssetAttribute {
    name: string;
    value: string;
}

export interface AdmAssetsApi$CreateAssetResult {
    assetId: number;
    number: number;
    serialnumber: string;
    shortUrlCode: string;
}

export interface AdmAssetsAttributesApi$AttributesAutocompletion {
    customAttributes: string[];
    productname: string;
    serialnumber: string;
}

export interface AdmAssetsImportApi$FileImportReview {
    assetCount: number;
    assetInserts: number;
    assetUpdates: number;
    didIgnoreColumn: boolean;
    filename: string;
}

export interface AdmAssetsImportApi$ImportReview {
    fileImportReviews: AdmAssetsImportApi$FileImportReview[];
}

export interface AdmAssetsImportHistoryApi$BundleEntry {
    bundleName: string;
    count: number;
    id: number;
    importDate: string;
    importerName: string;
}

export interface AdmAssetsImportHistoryApi$Query {
    page: number;
    pageSize: number;
}

export interface AdmAssetsImportHistoryApi$QueryResult {
    assets: AdmAssetsImportHistoryApi$QueryResultAsset[];
    attributes: string[];
    bundleName: string;
    totalAssets: number;
}

export interface AdmAssetsImportHistoryApi$QueryResultAsset {
    attributeValues: string[];
    id: number;
    productName: string;
    serialnumber: string;
}

export interface AdmAssetsImportHistoryApi$SingleCreationEntry {
    createdDate: string;
    creatorName: string;
    id: number;
    productName: string;
    serialnumber: string;
}

export interface AdmAssetsImportHistoryApi$SingleCreationsResult {
    items: AdmAssetsImportHistoryApi$SingleCreationEntry[];
    total: number;
}

export interface AdmAssetsQrApi$QrInfo {
    assetId: number;
    views: AdmAssetsQrApi$QrInfoView[];
}

export interface AdmAssetsQrApi$QrInfoView {
    defaultView: boolean;
    id: number;
    uiTitle: string;
    url: string;
}

export interface AdmAssetsQrNfcExportApi$InfoResult {
    latestJob: AdmAssetsQrNfcExportApi$InfoResultLatestJob | null;
    views: AdmAssetsQrNfcExportApi$InfoResultAssetFrontendView[];
}

export interface AdmAssetsQrNfcExportApi$InfoResultAssetFrontendView {
    attributeName: string;
    defaultView: boolean;
    id: number;
    uiTitle: string;
}

export interface AdmAssetsQrNfcExportApi$InfoResultLatestJob {
    jobId: number;
    jobstate: AdmAssetsQrNfcExportApi$LatestJobState;
}

export interface AdmAssetsQueryApi$AttributeFilter {
    attributeName: string;
    values: string[];
}

export interface AdmAssetsQueryApi$MainAttributeSort {
    ascending: boolean;
    column: AdmAssetsQueryApi$MainAttributeSortColumn;
}

export interface AdmAssetsQueryApi$Query {
    filter: AdmAssetsQueryApi$QueryFilter;
    page: number;
    pageSize: number;
    sortEither: AdmAssetsQueryApi$QuerySortEither;
}

export interface AdmAssetsQueryApi$QueryFilter {
    attributeFilters: AdmAssetsQueryApi$AttributeFilter[];
    bundleIds: number[];
    ids: number[];
    productNames: string[];
}

export interface AdmAssetsQueryApi$QueryResult {
    attributes: AdmAssetsQueryApi$QueryResultAttribute[];
    items: AdmAssetsQueryApi$QueryResultEntry[];
    totalElements: number;
    userAttributeColumns: AdmAssetsQueryApi$QueryResultAttribute[];
}

export interface AdmAssetsQueryApi$QueryResultAttribute {
    id: number;
    name: string;
}

export interface AdmAssetsQueryApi$QueryResultEntry {
    attributeValues: (string | null)[];
    id: number;
    number: number;
    productName: string;
    protectionEntryCount: number;
    protectionGroupCount: number;
    ref: string;
    serialnumber: string;
}

export interface AdmAssetsQueryApi$QuerySortEither {
    attributes: AdmAssetsQueryApi$SortOnAttribute[] | null;
    main: AdmAssetsQueryApi$MainAttributeSort | null;
}

export interface AdmAssetsQueryApi$SortOnAttribute {
    ascending: boolean;
    attributeName: string;
}

export interface AdmAssetsQueryAutocompletionApi$AutocompleteAttributeValues {
    values: string[];
}

export interface AdmAssetsQueryAutocompletionApi$AutocompleteImportBundle {
    id: number;
    name: string;
}

export interface AdmAssetsQueryAutocompletionApi$AutocompleteImportBundles {
    bundleNames: AdmAssetsQueryAutocompletionApi$AutocompleteImportBundle[];
}

export interface AdmAssetsQueryAutocompletionApi$AutocompleteProductName {
    productNames: string[];
}

export interface AdmAssetsQueryAutocompletionApi$CustomAttributeNames {
    list: string[];
    userFilterSelected: string[];
    userSelected: string[];
}

export interface AdmAssetsQueryAutocompletionApi$SetCustomAttributeNames {
    filterList: string[];
    list: string[];
}

export interface AdmAssetsSearchApi$Query {
    query: string;
}

export interface AdmAssetsSearchApi$QueryAssetResult {
    assetLabel: string;
    id: number;
}

export interface AdmProtectionEmailGroupsApi$EmailGroupsModel {
    entries: AdmProtectionEmailGroupsApi$EmailGroupsModelEntry[];
    name: string;
}

export interface AdmProtectionEmailGroupsApi$EmailGroupsModelEntry {
    emailOrDomain: string;
}

export interface AdmProtectionEmailGroupsApi$GetEmailGroupsEntry {
    assetCount: number;
    emails: string[];
    folderCount: number;
    id: number;
    inUse: boolean;
    name: string;
}
export interface FrontendAssetScanApi$Result {
    customViewResult: FrontendAssetScanApi$ResultCustomView | null;
    defaultViewResult: FrontendAssetScanApi$ResultDefaultView | null;
}

export interface FrontendAssetScanApi$ResultCustomView {
    attrValue: string | null;
    urlSlug: string;
}

export interface FrontendAssetScanApi$ResultDefaultView {
    productname: string | null;
    serialnumber: string | null;
}
export const AdmAssetProtectionApi = {
  get: (orgId:number,assetId:number) : Promise<AdmAssetProtectionApi$AssetProtection> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/protection/" + assetId + "")
  },
  set: (orgId:number,assetId:number,input:AdmAssetProtectionApi$AssetProtectionInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/protection/" + assetId + "",input)
  },
}
export const AdmAssetsApi = {
  bulkAssetEdit: (orgId:number,input:AdmAssetsApi$BulkAssetEdits) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/bulk_assets_edit",input)
  },
  bulkAssetsDelete: (orgId:number,input:AdmAssetsApi$BulkAssetDelete) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/bulk_assets_delete",input)
  },
  checkSerialnumber: (orgId:number,input:AdmAssetsApi$CheckSerialnumber) : Promise<AdmAssetsApi$CheckSerialnumberResult> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/check_serialnumber",input)
  },
  createAsset: (orgId:number,input:AdmAssetsApi$CreateAsset) : Promise<AdmAssetsApi$CreateAssetResult> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/create_asset",input)
  },
}
export const AdmAssetsAttributesApi = {
  getAttributesForAutocomplete: (orgId:number) : Promise<AdmAssetsAttributesApi$AttributesAutocompletion> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/attributes/attributes_autocomplete")
  },
}
export const AdmAssetsImportApi = {
  importFiles: (orgId:number,files:Array<File>,refAsFirstColumn:string,deleteUnmappedAttributes:string) : Promise<string> => {
    return JsonApi.post_form("api/admin/bc/assets/org/" + orgId + "/assets/import/import_files",{"files": files,"refAsFirstColumn": refAsFirstColumn,"deleteUnmappedAttributes": deleteUnmappedAttributes})
  },
  importFilesReview: (orgId:number,files:Array<File>,refAsFirstColumn:string) : Promise<AdmAssetsImportApi$ImportReview> => {
    return JsonApi.post_form("api/admin/bc/assets/org/" + orgId + "/assets/import/import_files_review",{"files": files,"refAsFirstColumn": refAsFirstColumn})
  },
}
export const AdmAssetsImportHistoryApi = {
  getHistory: (orgId:number) : Promise<Array<AdmAssetsImportHistoryApi$BundleEntry>> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/import/history")
  },
  queryBundleAssets: (orgId:number,bundleId:number,query:AdmAssetsImportHistoryApi$Query) : Promise<AdmAssetsImportHistoryApi$QueryResult> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/import/history/" + bundleId + "/assets",query)
  },
  querySingleCreations: (orgId:number,query:AdmAssetsImportHistoryApi$Query) : Promise<AdmAssetsImportHistoryApi$SingleCreationsResult> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/import/history/single_creations",query)
  },
}
export const AdmAssetsQrApi = {
  downloadBrandedPng: (orgId:number,viewId:number,assetId:number) : Promise<unknown> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/qr/qr/branded/png?viewId="+ ( viewId == null ? "" : viewId ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
  getQrInfo: (orgId:number,assetId:number) : Promise<AdmAssetsQrApi$QrInfo> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/qr/qr/" + assetId + "/info")
  },
  getQrPng: (orgId:number,viewId:number,assetId:number) : Promise<unknown> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/qr/qr/png?viewId="+ ( viewId == null ? "" : viewId ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
}
export const AdmAssetsQrNfcExportApi = {
  getInfo: (orgId:number) : Promise<AdmAssetsQrNfcExportApi$InfoResult> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/qr_nfc/export/info")
  },
  startQrNfcExportJob: (orgId:number,viewId:number,jobType:AdmAssetsQrNfcExportApi$ApiJobType,exportAll:boolean,query:AdmAssetsQueryApi$Query) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/qr_nfc/export/start_job?viewId="+ ( viewId == null ? "" : viewId ) +"&jobType="+ ( jobType == null ? "" : jobType ) +"&exportAll="+ ( exportAll == null ? "" : exportAll ) +"",query)
  },
}
export const AdmAssetsQueryApi = {
  queryList: (orgId:number,query:AdmAssetsQueryApi$Query) : Promise<AdmAssetsQueryApi$QueryResult> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/query/queryList",query)
  },
}
export const AdmAssetsQueryAutocompletionApi = {
  autocompleteAttributeValues: (orgId:number,attributeName:string,query:string) : Promise<AdmAssetsQueryAutocompletionApi$AutocompleteAttributeValues> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/query/autocompletion/autocomplete_attribute_values?attributeName="+ ( attributeName == null ? "" : attributeName ) +"&query="+ ( query == null ? "" : query ) +"")
  },
  autocompleteImportBundles: (orgId:number,productNameQuery:string) : Promise<AdmAssetsQueryAutocompletionApi$AutocompleteImportBundles> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/query/autocompletion/autocomplete_import_bundle_names?productNameQuery="+ ( productNameQuery == null ? "" : productNameQuery ) +"")
  },
  autocompleteProductName: (orgId:number,productNameQuery:string) : Promise<AdmAssetsQueryAutocompletionApi$AutocompleteProductName> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/query/autocompletion/autocomplete_asset_product_names?productNameQuery="+ ( productNameQuery == null ? "" : productNameQuery ) +"")
  },
  getCustomAttributeNames: (orgId:number) : Promise<AdmAssetsQueryAutocompletionApi$CustomAttributeNames> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/assets/query/autocompletion/custom_attribute_names")
  },
  setCustomAttributeNames: (orgId:number,input:AdmAssetsQueryAutocompletionApi$SetCustomAttributeNames) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/assets/query/autocompletion/custom_attribute_names",input)
  },
}
export const AdmAssetsSearchApi = {
  search: (orgId:number,query:AdmAssetsSearchApi$Query) : Promise<Array<AdmAssetsSearchApi$QueryAssetResult>> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/assets/search",query)
  },
}
export const AdmProtectionEmailGroupsApi = {
  addEmailGroup: (orgId:number,input:AdmProtectionEmailGroupsApi$EmailGroupsModel) : Promise<void> => {
    return JsonApi.post("api/admin/bc/assets/org/" + orgId + "/protection_email_groups/add_email_group",input)
  },
  deleteEmailGroup: (orgId:number,emailGroupId:number) : Promise<void> => {
    return JsonApi.del("api/admin/bc/assets/org/" + orgId + "/protection_email_groups/delete_email_group?emailGroupId="+ ( emailGroupId == null ? "" : emailGroupId ) +"")
  },
  getEmailGroups: (orgId:number) : Promise<Array<AdmProtectionEmailGroupsApi$GetEmailGroupsEntry>> => {
    return JsonApi.get("api/admin/bc/assets/org/" + orgId + "/protection_email_groups/email_groups")
  },
  updateEmailGroup: (orgId:number,emailGroupId:number,input:AdmProtectionEmailGroupsApi$EmailGroupsModel) : Promise<void> => {
    return JsonApi.put("api/admin/bc/assets/org/" + orgId + "/protection_email_groups/update_email_group?emailGroupId="+ ( emailGroupId == null ? "" : emailGroupId ) +"",input)
  },
}

export const FrontendAssetScanApi = {
  assetLookup: (orgId:number,query:string) : Promise<FrontendAssetScanApi$Result> => {
    return JsonApi.get("public-api/asset_frontend/bc/assets/frontend/" + orgId + "/scan/asset_lookup?query="+ ( query == null ? "" : query ) +"")
  },
  scanNameplate: (orgId:number,file:File) : Promise<FrontendAssetScanApi$Result> => {
    return JsonApi.post_form("public-api/asset_frontend/bc/assets/frontend/" + orgId + "/scan/scan_image",{"file": file})
  },
}
